import { Flex } from "@minervaproject/fds";

import { BreakoutDetails } from "./breakout_details";

import { useAppSelector } from "hooks/redux_hooks";
import { classroomSelectors } from "store";

// TODO: present staff, pinned groups
function ActiveBreakout({ breakoutSessionId }: { breakoutSessionId: string }) {
  const breakout = useAppSelector(classroomSelectors.selectActiveBreakout());

  if (!breakout) return null;

  return (
    <Flex direction="column" none>
      <BreakoutDetails breakout={breakout} activeBreakoutSessionId={breakoutSessionId} />
    </Flex>
  );
}

export { ActiveBreakout };
